import { useMemo } from 'react';

import { useBrandId } from '~/theme/hooks/useBrandId';

export const useActiveBrandEffect = (brandEffectEnabled = false) => {
	const brandId = useBrandId();

	const activeBrandEffect = useMemo(() => {
		return brandEffectEnabled ? brandId : '';
	}, [brandEffectEnabled, brandId]);

	return activeBrandEffect;
};
